import UnallocatedScansList from "./UnallocatedScansList";

export default UnallocatedScansList;
